// Triệu Hồi (placeholder, P1). Là nơi DUY NHẤT được gọi toast (UI_SPEC §4.4).
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { toast } from '@state/modules/ui';
import { ScreenPlaceholder } from '../Placeholder';

export function SummonScreen(): JSX.Element {
  return (
    <ScreenPlaceholder tab="companions" screen="summon">
      <button
        type="button"
        class="ht-hotspot"
        data-id="hotspot-toast"
        style={{ left: '150px', top: '420px' }}
        onClick={() => toast('ui.placeholder.toast.text')}
      >
        {t('ui.placeholder.toast')}
      </button>
    </ScreenPlaceholder>
  );
}
